import { render, staticRenderFns } from "./RollingDetailRow.vue?vue&type=template&id=06787041&scoped=true"
import script from "./RollingDetailRow.vue?vue&type=script&lang=js"
export * from "./RollingDetailRow.vue?vue&type=script&lang=js"
import style0 from "./RollingDetailRow.vue?vue&type=style&index=0&id=06787041&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06787041",
  null
  
)

export default component.exports